var _path, _line, _line2, _line3, _circle, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6836 21.9453H3.57617V93.4671H59.261V56.7396",
    stroke: "#16161E",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48.5327,
    y1: 64.8262,
    x2: 14.3045,
    y2: 64.8262,
    stroke: "#16161E",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48.5327,
    y1: 74.0215,
    x2: 14.3045,
    y2: 74.0215,
    stroke: "#16161E",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.1631,
    y1: 82.707,
    x2: 14.3044,
    y2: 82.707,
    stroke: "#16161E",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3044,
    cy: 31.653,
    r: 30.1413,
    fill: "#AFFFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0217 36.5059C23.0217 38.9221 21.063 40.8809 18.6467 40.8809C16.2305 40.8809 14.2717 38.9221 14.2717 36.5059C14.2717 34.0896 16.2305 32.1309 18.6467 32.1309C21.063 32.1309 23.0217 34.0896 23.0217 36.5059Z",
    stroke: "#16161E",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9826_14765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4626 12.7812V18.9704",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 28.6484H54.8809",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5845 35.0938H54.8809",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1274 41.2109H54.8809",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1801 38.2324C64.9639 38.2324 66.41 36.8053 66.41 35.0449C66.41 33.2845 64.9639 31.8574 63.1801 31.8574C61.3963 31.8574 59.9502 33.2845 59.9502 35.0449C59.9502 36.8053 61.3963 38.2324 63.1801 38.2324Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.374 32.7103L71.6178 26.7891",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8223 46.7497C54.1183 48.9155 57.0042 50.3738 60.127 50.9463C63.2497 51.5188 66.4738 51.1806 69.4049 49.9732C72.3359 48.7657 74.8467 46.7413 76.6302 44.1476C78.4136 41.5539 79.3924 38.5035 79.4466 35.3695C79.5009 32.2355 78.6283 29.1538 76.9356 26.5016C75.243 23.8493 72.8037 21.7415 69.9161 20.4359C67.0286 19.1303 63.8181 18.6837 60.6773 19.1506C57.5366 19.6175 54.6019 20.9778 52.2322 23.0649",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0481 12.7812H69.3085",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9826_14765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 39.5294,
    fill: "white",
    transform: "translate(38 12.2344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyRules);
export default __webpack_public_path__ + "static/media/easy_rules.52514d9d5f5ba003462d714daf14678b.svg";
export { ForwardRef as ReactComponent };